import React, { ReactNode } from 'react';

import styles from './styles.module.css';

interface HeaderTitleProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
}

const HeaderTitle: React.FC<HeaderTitleProps> = ({ title, subtitle, icon }) => {
  return (
    <div className={styles.headerTitleContainer}>
      {icon && <div className={styles.iconWrapper}>{icon}</div>}
      <span className={styles.title}>{title}</span>
      {subtitle && (
        <>
          <span className={styles.separator}>|</span>
          <span className={styles.subtitle}>{subtitle}</span>
        </>
      )}
    </div>
  );
};

export default HeaderTitle;
